import { useSelector } from "react-redux";

//import { useFetchOneCompany } from "@lhd/hooks";
import { PERMISSIONS } from "@lhd/constants";
import { user } from "../users/selector";
import { getCompany } from "./selector";

export type ReceivedProps = Record<string, any>;

const useCompanies = (props: ReceivedProps) => {
  const company = useSelector(getCompany);
  const auth = useSelector(user);

  const companyId = company?.id;
  ///const { data, isLoading } = useFetchOneCompany(companyId);

  const permission = auth?.role_types;
  const fulPermission = auth?.role_types.includes(
    PERMISSIONS["full_permission"],
  );

  return {
    ...props,
    // data: company ? [data] : [],
    // isLoading: company ? isLoading : false,
    auth,
    permission,
    fulPermission,
  };
};

export type Props = ReturnType<typeof useCompanies>;

export default useCompanies;
